<template>
    <div class="table-content" >
        <div class="flex column gap-20" v-if="ticket">
            <div class="header-section flex gap-10 has-breadcrumbs">
                
                <text class="first-el">
                    <router-link  to="/tasks/" class="main-item">
                        Tasks 
                    </router-link>
                </text>
                <img  src="@/assets/arrow-opener.svg" alt="arrow-right"  class="p-10" />
                <div class="first-el">
                    <router-link :to="linkToWorkFlow" class="main-item">
                        {{ sectionName }} 
                    </router-link>
                </div>
            </div>
            <div class="flex container">
                <div class="details">
                    <div class="container-header">
                        Task details
                    </div>
                    <div class="ticket-info">
                        <div class="description-header bold-text">Description: </div>
                        <div class="ticket-subject" v-html="messages[messages.length -1].message"></div>
                    
                    
                        <div class="ticketid-title">Created At: </div>
                        <div class="ticket-subject bold-text" >
                            {{ dayjs(ticket.createdAt, 'YYYY-MM-DD HH:MM').format('DD/MM/YYYY HH:MM') }}
                        </div>

                        <div class="ticketid-title">Creator: </div>
                        <div class="ticketid-value bold-text flex gap-4 align-center">
                            <p>{{ ticket.creator_.username }}</p>
                        </div>
                        <div class="ticketid-title">Assignee: </div>
                        <div class="ticketid-value bold-text flex gap-4 align-center">
                            <p>{{ ticket.assignee_.username ? ticket.assignee_.username: 'N/A' }}</p>
                        </div>

                        <div class="ticketid-title">Section{{ referances.length > 1 ? 's' : '' }}: </div>
                        <div class="ticketid-value bold-text flex gap-4 flex column gap-5 align-start justify-start">
                            <div v-for=" referance in referances" :key="referance.id" >
                                <div class="flex gap-5px row wrap">
                                    <span class="no-bold">{{ sectionTypeName(referance.section_type) }}:</span>
                                    <div class='hoverable' @click="redirectTo(referance, 'section')" v-if="referance.section_type == 'entity'"> {{ concernMap[referance.section_id].name }}</div>
                                    <div class='hoverable' @click="redirectTo(referance, 'section')" v-if="referance.section_type == 'individual'"> {{ concernMap[referance.section_id].firstName }} {{ concernMap[referance.section_id].lastName }}</div>
                                </div>
                                <div class='hoverable' @click="redirectTo(referance, 'file')" v-if="referance.file_id"> {{ Utils.typeToName(concernMap[referance.file_id].documentType) }}</div>
                            </div>

                        </div>
                        <!-- <div class="ticket-severity info-label">Severity</div>
                        <div class="ticket-severity-value bold-text">{{ ticket.severity }}</div> -->
                        <div class="ticket-status info-label">Status</div>
                        <div class="ticket-status-value bold-text flex status-change">
                            <InpComponent
                                label=""
                                :style="'margin-bottom:0;'"
                                class="status-select mb-0"
                                type="options"
                                :options="statusOptions"
                                key_ref="task_status"
                                :value="ticket.task_status"
                                @inputChange="inputChange"/>
                                <button class='h-content buttons' v-if="statusChanged" @click="saveTicketStatus">
                                    Save
                                </button>
                        </div>
                        <!-- <div v-else class="ticket-status-value bold-text">{{ ticket.status }}</div> -->
                    </div>
                </div>
                <div class="details">
                    <div class="container-header">
                        Disscusion 
                        <button class="add-more-details transparent" @click="addMoreInfo">
                            Add more details
                        </button>
                    </div>
                    <div class="message-list">
                        <div v-for="message in messages" :key="message.id">
                            <div class="message">
                                <div class="message-header">
                                    <div class="message-author"><text v-if="message.type == 'admin'">Support </text>{{ message.username || message.user_id || message.admin_id }}</div>
                                    <div class="message-date">{{ dayjs(message.createdAt).format('MMM DD, YYYY hh:mm A') }}</div>
                                </div>
                                <div class="message-content" v-html="message.message"></div>
                                <div class="message-attachments" v-if="message.attachment && message.attachment.length">
                                    <div class='attachment' v-for="attachment of message.attachment">
                                        <img src="@/assets/file.svg" class='fileicon'>
                                        <div class="filename">
                                            <div class="name-of-the-file">{{ attachment.filename }}</div>
                                            <div class="size-of-the-file">{{ Utils.calculateFileSize(attachment.filesize) }}</div>
                                        </div>
                                        <img src="@/assets/download.svg" class='download' @click="download(attachment)">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PopupCover  v-if="showPopups" @close="closePopup">
            <CreateTicket 
                class='popup-content'
                @close="closePopup" 
                @ticketInfoUpdate="createTickethandler"/>
        </PopupCover>
    </div>
</template>

<script setup>
    import { ref,onMounted, computed } from 'vue'
    import { useStore } from 'vuex'
    import { useRouter, useRoute } from 'vue-router'
    import API from '../api/index.js'
    import dayjs from 'dayjs'
    import Utils from '@/utils';

    import CreateTicket from '../components/CreateTicket.vue'
    import PopupCover from '../components/PopupCover.vue'
    import InpComponent from '@/components/InpComponent.vue'


    const route = useRoute();
    const props = defineProps(['id', 'task_id']);
    const store = useStore();
    const companyData = computed(() => store.state.companyData);

    const user = store.state.user;
    const ticket = ref(null);
    const messages = ref(null);
    const showPopups = ref(false);
    const concernMap = ref(null)
    const status_changed = ref(null);
    const loading = ref(false)

    const linkToWorkFlow = computed( () => ({name: 'client-item', params: {id: companyData.value?._id}}) )

    const sectionName = computed(() => {
        if (!companyData.value) {
            return 'N/A';
        }
        if (companyData.value.company_type == 'corporate') {
            return companyData.value.name.value + ' Corporate';
        } 
        return companyData.value.first_name.value + " " + companyData.value.last_name.value + ' Account Holder';
    })
    onMounted(async () => {
        const response = await API.getTask(props.task_id);
        ticket.value = response.task;
        messages.value = response.messages;
        concernMap.value = response.concern;
        
        if (!companyData.value) {
            await API.loadDashboardData({company_id: props.id});
            store.dispatch('loadEnv', { id: props.id } );
        }
    })

    const statusOptions = computed(() => {
        if (ticket.value.assigned_to_user_id == user._id) {
            return [{
                value: 'to do',
                text: 'To Do'
            },{
                value: 'review',
                text: 'Review'
            }]
        } else if (ticket.value.creator == user._id ) {
            console.log('create option')
            return [{
                value: 'to do',
                text: 'To Do'
            }, {
                value: 'done',
                text: 'Done',
            }]
        }
        
    })

    const statusChanged = computed(() => status_changed.value && status_changed.value != ticket.value.status);



    function redirectTo(referance, type){

        let url = window.location.origin;
        url += `/${companyData.value._id}`;

        if (type == 'section') {
            url += `/${concernMap.value[referance.section_id].source}/?highlight=id${referance.section_id}`;
        } else if (referance.section_type == 'corporate_file') {
            console.log('referance.file_id', referance.file_id, concernMap.value[referance.file_id])
            url += '/corporate/?highlight=id' + referance.file_id;
        } else if (type == 'file' ) {
            url += `/${concernMap.value[referance.section_id].source}/?highlight=id${referance.file_id}`;
        }
        window.open(url, '_blank');
    }
    function addMoreInfo(){
        showPopups.value = true
    }

    function sectionTypeName(name) {
        let keyName = {
            'corporate_file': 'Corporate File',
            'entity': 'Entity',
            'individual': 'Individual',
        }
        return keyName[name] || name
    }
    const referances = computed(() => {
        if (ticket.value.referances.length) {
            try {
                return JSON.parse(ticket.value.referances)
            } catch (error) {
                return []
            }
        }
        return []
    })

    async function download(attachment){
        await API.downloadSupportFile(attachment)
    }
    function attachment(file) {
        
    }
    async function createTickethandler(ticketInfo) {

        if (loading.value == true) {
            return;
        }
        loading.value = true;
        const ticket = ticketInfo.ticket;
        const fileInfo = ticketInfo.files;

        if (!ticket.content) {
            loading.value = false;
            return
        }
        let fileIds = []
        for (let file of fileInfo) {
            let fileId = await API.uploadTaskFile(file);
            fileIds.push(fileId);
        }

        const result = await API.sendTaskMessage({
            task: {
                content: ticket.content, 
                task_id: props.task_id
            },
            files: fileIds
        })
        if (result.status == 'success'){
            messages.value.unshift(result.message)
            closePopup();
        }
        loading.value = false;
    }
    async function saveTicketStatus(){
        const result = await API.updateTaskStatus({
            task_id: props.task_id,
            status: status_changed.value
        })
        if (result.status == 'success'){
            ticket.value.status = status_changed.value
            status_changed.value = null
            store.dispatch('addNotification', {text: 'Task Status Updated successfully', type: 'success'})

        }
    }
    function inputChange(event){
        status_changed.value = event[1]
    }
    function closePopup(){
        showPopups.value = false
    }

</script>


<style lang="scss" scoped>

.download {
    margin-left: auto;
    cursor: pointer;
    width: 15px;
    height: 15px;
}

.filename {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.message-attachments {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
.size-of-the-file {
    font-size: 0.8rem;
    color: rgb(116 119 127);
}
.details {
    :deep(p) {
        margin: 0;
    }
}
.name-of-the-file {
    display: flex;
    align-items: center;
    color: black;
    font-size: 0.9rem;

    text-align: left;
    overflow: hidden;
    //text-wrap: nowrap;
    text-overflow: ellipsis;
}
.fileicon {
    width: 40px;
    height: 40px;
}
.hoverable {
    cursor: pointer;
    text-decoration: underline;
    &:hover {
        text-decoration: none;
    }
}

.attachment {
    border-radius: .5rem;
    border-width: 1px;
    -moz-column-gap: .5rem;
    column-gap: .5rem;
    grid-template-columns: fit-content(100%) 1fr;
    border-color: rgb(224, 223, 223);
    border-style: solid;
    border-width: 1px;
    background-color: rgb(255 255 255);
    padding: .8rem;
    display: flex;
    align-items: center;
}

.message-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-height: calc(100vh - 250px);
    overflow-y: auto;
    padding: 1rem 1.5rem;
}
.message-content {
    font-size: 0.9rem;
    line-height: 1.5rem;
    color: rgb(24 28 34);
    text-align: left;
    &:deep(p) {
        margin: 0;
    }
    
}
.status-select {
    margin-top: 5px;
    width: fit-content;
}

.message-author {
    text-align: left;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    width: 50%;
    word-break: break-word;
    color: black;
}
.message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.message-date {
    color: rgb(91 94 102);
    background: rgb(224 226 236);
    border-radius: .125rem;
    height: 1rem;
    text-wrap: nowrap;
    width: fit-content;
    font-size: .75rem;
    font-weight: 700;
    line-height: 1rem;
    padding: .125rem;
}
.message {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    border-radius: 10px;
    background-color: rgb(246 246 252);
    border: 1px solid var(--border-color);
    padding: .75rem;
}
.table-content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}

.container {
    display: flex;
    gap: 20px;
    width: 1000px;
}
.popup-content {
    max-width: 600px;
    padding-top: 20px;
    &:deep(.header) {
        padding-bottom: 0;
    }
    &:deep(.add-new-ticket-info) {
        margin-top: 0;
    }
}

.no-bold {
    font-weight: 400;
}

.container-header {
    align-items: center;
    border-bottom-width: 1px;
    box-sizing: content-box;
    display: flex;
    flex-direction: row;
    height: 2.5rem;
    justify-content: space-between;
    padding: 1rem 1.5rem;
    border-bottom: 1px solid var(--border-color);

    box-sizing: content-box;
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.75rem;
    margin: 0;
    --tw-text-opacity: 1;
    color: rgb(24, 28, 34);

    button {
        width: fit-content;
        padding: 10px 30px;

    }
}
.details {
    max-width: 500px;
    flex: 1;
    background: white;
    border: 1px solid var(--border-color);
    border-radius: 15px;
    height: fit-content;

}
.ticket-info {
    text-align: left;
    padding: 1rem 1.5rem;

}

.bold-text {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5rem;
    color: rgb(24 28 34);   
}
.ticket-subject {
    font-size: 0.9rem;
    line-height: 1.75rem;
    color: rgb(24 28 34);
}
.ticketid-title {
    font-size: .875rem;
    line-height: 1.25rem;
    margin-top: 1rem;
    color: rgb(116 119 127)
}
.info-label {
    font-size: .775rem;
    line-height: 1.25rem;
    margin-top: 1rem;
    margin-bottom: -8px;
    color: rgb(116 119 127)
}
.status-change {
    justify-content: space-between;
    width: 100%;
    margin-bottom: 0;

    button {
        width: fit-content;
        padding: 10px 30px;
        margin: 0;
    }
}
.user-label {
    background-color: rgb(236 240 255);
    border-radius: 50%;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--primary-color);
}
.has-breadcrumbs {
    display: flex;
    align-items: center;
    font-size: 16px;
    .first-el > a {
        font-size: 16px;
        color: var(--primary-color);
        text-decoration: none;
    }
}
.header-section[class] {
    margin-bottom: 0;
    padding-top: 0;
}
</style>